module.exports = __webpack_public_path__ + "img/incein-circle-1.d3af3e85.svg";